import { useEffect, useState } from 'react';
import createSingleI18nProvider from 'I18n/init/providers/createSingleI18nProvider';
import getLangLocale from 'I18n/utils/getLangLocale';
import { loadLanguageFile } from '../utils/asyncLanguage';
import { logError } from '../utils/errorUtils';
import { ERROR_SOURCES, ERROR_TYPES } from '../utils/errorConstants';
const loadLanguageAndRegister = async () => {
  const langModule = await loadLanguageFile();
  await createSingleI18nProvider({
    language: getLangLocale()
  }).register(langModule.default);
};
export const useLanguageLoader = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    loadLanguageAndRegister().catch(loadingError => {
      logError(loadingError, {
        type: ERROR_TYPES.COMPONENT_LOADING,
        source: ERROR_SOURCES.LANGUAGE_LOADER,
        operation: 'loadLanguageAndRegister'
      });
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  // We don't report errors here because the component which uses the strings will render default empty strings
  return {
    loading
  };
};